import { NODE_ENV_LOCAL_OR_DEVELOPMENT } from '../constants/env';

export const ANALYTICS_EVENT_CHAT_GIF_PICKER = 'chat_gif_picker';
export const ANALYTICS_EVENT_CHAT_GIF_MESSAGE_SENT = 'chat_gif_message_sent';

export const ANALYTICS_EVENT_FILE_UPLOAD_ATTEMPTED = 'file_upload_attempted';
export const ANALYTICS_EVENT_FILE_UPLOAD_SUCCESS = 'file_upload_success';
export const ANALYTICS_EVENT_FILE_UPLOAD_FAILED_SIZE_LIMIT =
  'file_upload_failed_size_limit';
export const ANALYTICS_EVENT_FILE_UPLOAD_ERROR_DISPLAYED =
  'file_upload_error_displayed';

export const ANALYTICS_EVENT_SUMMARY_VIEWED = 'summary_viewed';
export const ANALYTICS_EVENT_SUMMARY_SCROLLED = 'summary_scrolled';
export const ANALYTICS_EVENT_SUMMARY_COPIED_TEXT = 'summary_copied_text';
export const ANALYTICS_EVENT_SUMMARY_REGENERATION_CLICKED =
  'summary_regeneration_clicked';
export const ANALYTICS_EVENT_SUMMARY_REGENERATION_FAILED =
  'summary_regeneration_failed';
export const ANALYTICS_EVENT_SUMMARY_REGENERATION_SUCCESS =
  'summary_regeneration_success';

export const ANALYTICS_EVENT_USER_MENU_OPENED = 'user_menu_opened';
export const ANALYTICS_EVENT_SEND_FEEDBACK_CLICKED = 'send_feedback_clicked';
export const ANALYTICS_EVENT_DOWNLOAD_DESKTOP_APP_CLICKED =
  'download_desktop_app_clicked';

export const ANALYTICS_EVENT_VIDEO_UPGRADE_INTEREST_REQUESTED = 'video_upgrade_interest_requested';

export const ANALYTICS_EVENT_CALL_LOG_SELECTION_STARTED = 'call_log_selection_started';
export const ANALYTICS_EVENT_CALL_LOG_SELECTED = 'call_log_selected';
export const ANALYTICS_EVENT_CALL_LOG_DESELECTED = 'call_log_deselected';
export const ANALYTICS_EVENT_CALL_LOG_SELECT_ALL = 'call_log_select_all';
export const ANALYTICS_EVENT_CALL_LOG_REACH_LIMIT = 'call_log_reach_limit';
export const ANALYTICS_EVENT_CALL_LOG_DELETE_SUCCESS = 'call_log_delete_success';
export const ANALYTICS_EVENT_CALL_LOG_DELETE_FAILED = 'call_log_delete_failed';

export const ANALYTICS_EVENT_CONVERSATION_DETAILS_CALL_HISTORY_OPTION_VIEWED =
  'conversation_details_call_history_option_viewed';
export const ANALYTICS_EVENT_CONVERSATION_DETAILS_CALL_HISTORY_SELECTED =
  'conversation_details_call_history_selected';
export const ANALYTICS_EVENT_CONTACT_DETAILS_CALL_HISTORY_SELECTED =
  'contact_details_call_history_selected';

export const ANALYTICS_EVENT_TYPING_INDICATOR_SHOWN = 'typing_indicator_shown';

/**
 * Push an `event` and optional metadata to Google Tag Manager's data layer.
 *
 * @see https://tagmanager.google.com/#/container/accounts/6000369423/containers/30399222/workspaces/19
 *
 * @see https://analytics.google.com/analytics/web/#/report-home/a98911w213443318p204492464
 *
 * @param event GTM `event`
 * @param metadata Metadata to attach to the `event`
 */
export function pushToGTMDataLayer(
  event: string,
  metadata?: IGTMDataLayerMetadata
) {
  try {
    if (window['gtag']) {
      window['gtag']('event', event, {
        ...(metadata || {}),
        event,
      });
    }
  } catch (err) {
    if (NODE_ENV_LOCAL_OR_DEVELOPMENT) {
      console.debug(`Failed to send event ${event} to GTM.`);
    }
  }
}

/** Metadata provided to Google Tag Manager `event`s */
export interface IGTMDataLayerMetadata {
  [key: string]: string | number | boolean;
}

interface IAnalyticsUserProperties {
  userId: string | number;
  accountId: string | number;
  role?: string;
  seatType?: string;
}

export function setAnalyticsUserProperties(
  properties: IAnalyticsUserProperties
): void {
  const { userId, accountId, role, seatType } = properties;

  try {
    if (!window['gtag']) {
      if (NODE_ENV_LOCAL_OR_DEVELOPMENT) {
        console.debug('gtag not available, skipping user properties setup');
      }
      return;
    }

    window['gtag']('set', { user_id: userId });
    window['gtag']('set', 'user_properties', {
      person_id: userId,
      account_id: String(accountId),
      role: role ?? '',
      seat_type: seatType ?? '',
    });

    if (NODE_ENV_LOCAL_OR_DEVELOPMENT) {
      console.debug('GA user properties set:', {
        user_id: userId,
        account_id: String(accountId),
        role: role ?? '',
        seat_type: seatType ?? '',
      });
    }
  } catch (err) {
    if (NODE_ENV_LOCAL_OR_DEVELOPMENT) {
      console.error('Failed to set GA user properties:', err);
    }
  }
}
